import { useEffect, useRef } from "react";
import "rapidoc";
import { injectCopyButtons } from "../utils/rapidoc-buttons.js";
import {getAssetPath} from "../../../../utils/get-asset-path.js";

const modes = {
    light: {
        theme: "light",
        "bg-color": "#f3f3f4",
        "text-color": "#031B34",
        "nav-bg-color": "#031B34",
        "primary-color": "#1588f3",
    },
    dark: {
        theme: "dark",
        "bg-color": "#272A2F",
        "text-color": "#B4B5B7",
        "nav-bg-color": "#063a6c",
        "primary-color": "#1588f3",
    },
};

export default function RapidoDocView({ specUrl, modeKey, copyToClipboard, children }) {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const themeConfig = modes[modeKey] || modes.light;

        Object.entries(themeConfig).forEach(([k, v]) => el.setAttribute(k, v));

        if (specUrl) {
            el.setAttribute("spec-url", specUrl);
        }
    }, [modeKey, specUrl]);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;

        const onSpecLoaded = (e) => {
            injectCopyButtons({
                rapiDocEl: el,
                details: e.detail,
                copyToClipboard,
            });
        };

        el.addEventListener("spec-loaded", onSpecLoaded);
        return () => el.removeEventListener("spec-loaded", onSpecLoaded);
    }, [copyToClipboard]);

    useEffect(() => {
        const normalizeHash = () => {
            const { hash, pathname, search } = window.location;
            if (hash.includes("-#")) {
                const fixedHash = hash.replace("-#", "#");
                window.history.replaceState(null, "", pathname + search + fixedHash);
            }
        };

        window.addEventListener("hashchange", normalizeHash);
        normalizeHash();

        return () => window.removeEventListener("hashchange", normalizeHash);
    }, []);

    return (
        <rapi-doc
            ref={ref}
            id="doc"
            style={{ height: "100%", width: "100%", display: "block" }}
            update-route="true"
            route-prefix="/docs/"
            render-style="read"
            allow-authentication="false"
            nav-item-spacing="relaxed"
            show-method-in-nav-bar="as-colored-text"
            font-size="largest"
            load-fonts="false"
            allow-server-selection="true"
            show-header="false"
            schema-style="tree"
            sort-endpoints-by="summary"
            sort-tags="true"
        >
            <div slot="nav-logo" className="flex items-center justify-center px-3 py-3">
                <img src={getAssetPath("img/logo.svg")} alt="Sentry" className="h-auto w-auto" />
            </div>
            {children}
        </rapi-doc>
    );
}